var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7666 14.1842L17.8844 5.01008C16.5289 2.53895 13.6364 1.37489 10.9822 2.15765C9.99418 1.42988 8.77523 1 7.45729 1C4.17253 1 1.5 3.67278 1.5 6.95784V17.0403C1.5 20.3254 4.17253 22.9982 7.45729 22.9982C9.57625 22.9982 11.4404 21.8854 12.4972 20.2136C13.2725 21.4491 14.4585 22.3465 15.8708 22.7589C16.4235 22.9203 16.9871 23 17.5471 23C18.5351 23 19.513 22.7516 20.4039 22.2631C21.7988 21.4977 22.8124 20.2356 23.2588 18.7076C23.7042 17.1797 23.5282 15.5701 22.7684 14.1842H22.7666ZM16.2713 5.88176L18.3546 9.7956L13.4146 12.505V6.95692C13.4146 5.77819 13.0709 4.67828 12.4779 3.75252C14.0076 3.68561 15.5024 4.47846 16.2723 5.88084L16.2713 5.88176ZM7.45729 2.83318C9.73114 2.83318 11.5816 4.68378 11.5816 6.95784V11.0825H3.33301V6.95784C3.33301 4.68378 5.18344 2.83318 7.45729 2.83318ZM7.45729 21.165C5.18344 21.165 3.33301 19.3144 3.33301 17.0403V12.9157H11.5816V17.0403C11.5816 19.3144 9.73114 21.165 7.45729 21.165ZM21.4973 18.1943C21.1884 19.2521 20.4863 20.1265 19.5203 20.6563C18.5544 21.1861 17.439 21.3071 16.3831 21C15.3255 20.6911 14.4512 19.989 13.9269 19.033L13.3458 17.9423C13.3908 17.648 13.4137 17.3474 13.4137 17.0412V14.5976L19.2152 11.4161L21.1526 15.0568C21.6824 16.0229 21.8043 17.1375 21.4963 18.1952L21.4973 18.1943Z",
    fill: "#8f9bba",
    stroke: "white",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/Medication.929029f4c8d4b8703276eb53ecfc1c7f.svg";
export { ForwardRef as ReactComponent };